import "../css/VideoBooth.css";

import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import NavBar from "../webcomponents/NavBar";
import WebFooter from "../webcomponents/WebFooter";

const VideoBoothPage = () =>{

    const [userId, setUserId] = useState('');
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Parse the code parameter from the URL
        const searchParams = new URLSearchParams(location.search);
        const codeParam = searchParams.get('slimeId');

        // Update the state with the code
        if(codeParam !== null){
            setUserId(codeParam);
        }
        else{
            setIsLoading(false);
        }
    }, [location]);
    
    useEffect(() => {
        // Only call loadData when userId is not empty
        if (userId !== "") {
          loadData();
        }
    }, [userId]);

    const loadData = async() =>{
        const docRef = doc(db, "videobooth", userId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const loadedData = docSnap.data();
            setUserData(loadedData);
        } 
        else {
            console.log("No such document!");
        }

        setIsLoading(false);
    }

    const handleDownload = async (url, fileName) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();

            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName; // e.g. "abcd1234.mp4"
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Download failed:", err);
        }
    };


    const handleLinkClick = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    }

    const decors = [
    // Around VIDEO section (upper area)
    { shape: "circle",  pos: { left: "-40px",  top: "14%" }, rotation: "0deg",   scale: 0.5 },
    { shape: "triangle",pos: { right: "-55px", top: "8%"  }, rotation: "18deg",  scale: 0.4 },
    { shape: "zigzag",  pos: { right: "-60px", top: "26%" }, rotation: "-12deg", scale: 0.35 },

    // Around PHOTO 1 section (middle area)
    { shape: "circle",  pos: { left: "-55px",  top: "42%" }, rotation: "-10deg", scale: 0.35 },
    { shape: "square",  pos: { right: "-70px", top: "48%" }, rotation: "10deg",  scale: 0.6 },
    { shape: "zigzag",  pos: { left: "-60px",  top: "56%" }, rotation: "15deg",  scale: 0.5 },

    // Around PHOTO 2 section (lower area)
    { shape: "triangle",pos: { left: "-65px",  top: "68%" }, rotation: "14deg",  scale: 0.4 },
    { shape: "circle",  pos: { right: "-50px", top: "78%" }, rotation: "0deg",   scale: 0.3 },
    { shape: "zigzag",  pos: { right: "-70px", top: "90%" }, rotation: "-18deg", scale: 0.4 },
    ];


    function renderDecorShapes() {
    return decors.map((decor, index) => {
        const commonStyle = {
        position: "absolute",
        ...decor.pos, // uses left/right/top from the array
        transform: `rotate(${decor.rotation}) scale(${decor.scale})`,
        pointerEvents: "none",
        opacity: 0.45,
        zIndex: -10,
        };

        switch (decor.shape) {
        case "circle":
            return (
            <div key={index} style={{ ...commonStyle }}>
                <div
                style={{
                    width: "160px",
                    height: "160px",
                    borderRadius: "50%",
                    background: "#fceda7",
                }}
                />
            </div>
            );

        case "square":
            return (
            <div key={index} style={{ ...commonStyle }}>
                <div
                style={{
                    width: "160px",
                    height: "160px",
                    borderRadius: "25px",
                    background: "#c5db95",
                }}
                />
            </div>
            );

        case "triangle":
            return (
            <img
                key={index}
                src="/assets/decors/triangle.png"
                alt=""
                style={{ ...commonStyle, width: "200px" }}
            />
            );

        case "zigzag":
            return (
            <img
                key={index}
                src="/assets/decors/zigzag.png"
                alt=""
                style={{ ...commonStyle, width: "260px" }}
            />
            );

        default:
            return null;
        }
    });
    }

    if(!isLoading && !userData){
        return(
        <div className="home">
            <NavBar />
            <div style={{ marginTop: 80 }}>No video found for this link.</div>

            <div className="pink-btn" style={{width:"300px", height:"50px", aspectRatio:"auto", margin:"60px 0px"}}
                onClick={()=>handleLinkClick("https://lin.ee/Uoj6YqH")}
            >
                BOOK SESSION
            </div>
        </div>
        );
    }

    return(
        <div className="home">
            <NavBar />
            {renderDecorShapes()}

            {isLoading && <div style={{ marginTop: 80 }}>Loading your video…</div>}

            <div style={{marginTop:"80px", width:"100%", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                <div style={{height:"70dvh"}}>
                    {userData?.videoLink && (
                        <video
                            src={userData.videoLink}
                            autoPlay
                            controls
                            loop
                            playsInline
                            style={{ height:"100%", borderRadius: "16px",}}
                        />
                    )}
                </div>
                <div
                    onClick={()=>handleDownload(userData.videoLink, userData.userName + "_slimeville_vdo.mp4")}
                    className="download-btn"
                >
                    <img src="/assets/videobooth/download_icon.png" style={{height:"60%"}} />
                </div>
            </div>

            <div style={{marginTop:"50px", width:"100%", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                <div style={{height:"70dvh"}}>
                    {userData?.photoLink1 && (
                        <img
                            src={userData.photoLink1}
                            style={{ height:"100%", borderRadius: "16px",}}
                        />
                    )}
                </div>
                <div
                    onClick={()=>handleDownload(userData.photoLink1, userData.userName + "_slimeville_photo1.png")}
                    className="download-btn"
                >
                    <img src="/assets/videobooth/download_icon.png" style={{height:"60%"}} />
                </div>
            </div>

            <div style={{marginTop:"50px", marginBottom:"20px", width:"100%", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                <div style={{height:"70dvh"}}>
                    {userData?.photoLink2 && (
                        <img
                            src={userData.photoLink2}
                            style={{ height:"100%", borderRadius: "16px",}}
                        />
                    )}
                </div>
                <div
                    onClick={()=>handleDownload(userData.photoLink2, userData.userName + "_slimeville_photo2.png")}
                    className="download-btn"
                >
                    <img src="/assets/videobooth/download_icon.png" style={{height:"60%"}} />
                </div>
            </div>

            <div className="pink-btn" style={{width:"300px", height:"50px", aspectRatio:"auto", margin:"60px 0px", fontSize:"24px"}}
                onClick={()=>handleLinkClick("https://lin.ee/Uoj6YqH")}
            >
                BOOK SESSION
            </div>

            <WebFooter />
        </div>
    );
};

export default VideoBoothPage;